/**
 * 
 * @param {} element 
 * @param {} module 
 * @returns {} 
 */
function getElementNotFoundError(element, module) {
	return `could not find ${element} in module ${module}.`;
}


export {
	getElementNotFoundError
}